<h1 mat-dialog-title>
  <div [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
    {{ 'LABEL_FILTER' | translate }}
  </div>
</h1>

<div mat-dialog-content fxLayout="column" fxAlign="center center">
  <div fxLayout="column" fxLayoutGap="20px">

    <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">
      <!-- role -->
      <div>
        <mat-form-field class="width-100">
          <input 
            matInput
            required
            #roleInput
            formControlName="role" 
            [matAutocomplete]="roleAC"
            [placeholder]="'LABEL_ROLE' | translate" 
            (focus)="!roleAC.isOpen && getInitialData('role')"
            >
      
          <mat-icon 
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            *ngIf="roleInput.value"
            (click)="resetControl(formGroup.get('role')); roleInput.value = ''"
            >
          </mat-icon>
      
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!roleInput.value"
            >
          </mat-icon>
      
          <mat-autocomplete 
            [displayWith]="displayFn"
            #roleAC="matAutocomplete" 
            (closed)="roleInput.blur()"
            (opened)="autocompleteScroll('role','roleACRef','roleACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.role && roles?.length == 0"
              >
              {{ 'LABEL_NO_DATA' | translate }}
            </mat-option>
      
            <mat-option *ngFor="let item of roles" [value]="item">
              {{ item.code != 'all' ? (item.code + ' - ') : '' }} {{ item.description }}
            </mat-option>
      
            <mat-option *ngIf="loading.role" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
      
          <mat-error *ngIf="formGroup.controls['role'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error>   

          <mat-error *ngIf="formGroup.controls['role'].hasError('notExisting')">
              {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_ROLE' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Status -->
      <div>
        <mat-form-field class="form-field-filter">
          <mat-label>
            {{ 'LABEL_STATUS' | translate }}
          </mat-label>

          <mat-select formControlName="status" [compareWith]="compareWithFunc" required>
            <mat-option *ngFor="let opt of statuses" [value]="opt">
              {{opt.description}}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="formGroup.controls['status'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error> 
        </mat-form-field>
      </div>
    </form>

  </div>
</div>

<div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-button (click)="applyFilters()"> {{ 'LABEL_APPLY' | translate }} </button>
  <button type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  <button type="button" mat-button (click)="dialogRef.close()"> {{ 'LABEL_CANCEL' | translate }} </button>
</div>

<!-- buttons for mobile view -->
<div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-icon-button (click)="applyFilters()">
    <mat-icon svgIcon="check"></mat-icon>
  </button>

  <button type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>

  <button type="button" mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="cancel"></mat-icon>
  </button>
</div>